export default (driveType) => [
  {
    type: 'seq',
    title: '序号',
    width: 55,
  },
  {
    field: 'driveNo',
    title: '设备号',
    width: 120,
  },
  {
    field: 'reportTime',
    title: '上报时间',
    width: 150,
  },
  {
    field: 'temp',
    title: '温度',
    minWidth: 80,
    visible: driveType !== 'V',
  },
  {
    field: 'temp1',
    title: '温度1',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'temp2',
    title: '温度2',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'temp3',
    title: '温度3',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'temp4',
    title: '温度4',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'hum1',
    title: '湿度1',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'hum2',
    title: '湿度2',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'hum3',
    title: '湿度3',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'hum4',
    title: '湿度4',
    minWidth: 80,
    visible: driveType === 'V',
  },
  {
    field: 'location',
    title: '位置',
    minWidth: 150,
  },
]
